import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { DefaultModalLayout } from '../../../../../../../components/modal/layouts/default-modal-layout';
import { Note, NOTE_TYPE } from '../../../../../../../components/note/note';
import FontHeading3 from '../../../../../../../components/fonts/font-heading3/font-heading3';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';
import { IButtonProps } from '../../../../../../../components/inputs/button/button';
import ListLayout from '../../../../../../../components/layouts/list-layout/list-layout';
import '../../../../../../home/components/terms-acceptance-modal/terms-acceptance-modal.scss';
import FedexV2RegistrationStore from '../../../../stores/credentials/shipping/fedex-v2/fedex-v2-registration-store';

interface IProps {
    registration: FedexV2RegistrationStore;
    buttons: IButtonProps[];
    children: ReactNode;
}

const FedexV2RegistrationModalLayout: React.FC<IProps> = observer(({
    registration,
    buttons,
    children,
}) => (
    <DefaultModalLayout
        isCloseDisabled={false}
        onCloseClicked={registration.close}
        buttons={buttons}
    >
        <div className="terms-acceptance-modal">
            <ListLayout>
                <FontHeading3 color={FONT_COLOR.NEUTRAL11_MENU} variant={[FONT_VARIANT.BOLD]}>
                    FedEx account registration
                </FontHeading3>
                {registration.error && <Note type={NOTE_TYPE.ERROR} body={registration.error} />}
                {children}
            </ListLayout>
        </div>
    </DefaultModalLayout>
));

export default FedexV2RegistrationModalLayout;
